module.exports = __webpack_public_path__ + "img/20191116150805959.ffcd8144.jpg";